<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChevronLeft_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M9.537 12.891 5.25 8.606a.856.856 0 0 1 0-1.212l4.286-4.285a.856.856 0 1 1 1.212 1.212L7.069 8l3.68 3.68a.856.856 0 1 1-1.212 1.211"
    />
</svg>
